import * as React from 'react';

type Props = {
  variant?: 'info' | 'warning' | 'error';
  dismissible?: boolean;
  onDismiss?: () => void;
  children: React.ReactNode;
};

/**
 * V3InfoBanner — inline information/warning banner.
 *
 * Used in:
 *  - Location section: "Auto-filled from Step 2 address · Edit any field directly"
 *  - Advanced section: "Fully-Attached disclaimer" info box for RM/GF
 *  - BOM warnings: per-item warnings from state.bom.warningsInfo
 *  - Module selector: "greyed fields are read-only" for Aurora/OS projects
 *
 * Existing equivalents: soft-warning divs in ModuleSelectorComponent,
 * alert-danger divs in BomWarnings.
 */
const InfoIcon = () => (
  <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
    <circle cx="6.5" cy="6.5" r="5.5" stroke="currentColor" strokeWidth="1.3"/>
    <path d="M6.5 5.5v3M6.5 4.5h.01" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/>
  </svg>
);

const V3InfoBanner: React.SFC<Props> = ({
  variant = 'info',
  dismissible = false,
  onDismiss,
  children,
}) => (
  <div className={`v3-info-banner ${variant}`}>
    {variant === 'info' && <InfoIcon />}
    <div className="v3-info-banner-content">{children}</div>
    {dismissible && (
      <button type="button" className="v3-info-banner-close" onClick={onDismiss}>✕</button>
    )}
  </div>
);

export default V3InfoBanner;
